import { COMPLETE_SET_UP_ERRORS, ERROR_CODES } from 'state/error'
import { REQUIREMENT_TYPE_ENUM } from 'state/campaigns'
import { PLATFORM_ENUM } from 'services/api/constants'
import i18n from 'config/i18n'

export const ERROR_MESSAGES: Record<string, any> = {
    [COMPLETE_SET_UP_ERRORS.DESCRIPTION]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterCampaignDescription'),
    },
    [COMPLETE_SET_UP_ERRORS.IMAGES]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.uploadCampaignBanner'),
    },
    [COMPLETE_SET_UP_ERRORS.PAYOUT_DEADLINE]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.datePicker.selectDate'),
        [ERROR_CODES.CAMPAIGN_PAYOUT_DEADLINE_LESS_THAN_END_TIME]: i18n.t(
            'errorMessage.businessLogic.payoutBeforeEndDate',
        ),
    },
    [COMPLETE_SET_UP_ERRORS.REQUIREMENTS]: {
        [REQUIREMENT_TYPE_ENUM.AGE]: {
            min: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.textField.enterMinimumAge'),
            },
            max: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMaximumAge'),
            },
        },
        [REQUIREMENT_TYPE_ENUM.GENDER]: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectGender'),
        },
        [REQUIREMENT_TYPE_ENUM.FOLLOWER]: {
            [PLATFORM_ENUM.IG]: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumMaximumFollowers'),
            },
            [PLATFORM_ENUM.FB]: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumMaximumFriends'),
            },
            [PLATFORM_ENUM.TWITTER]: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumMaximumFollowers'),
            },
            [PLATFORM_ENUM.TIKTOK]: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumMaximumFollowers'),
            },
            [PLATFORM_ENUM.XIAOHONGSHU]: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumMaximumFollowers'),
            },
        },
        [REQUIREMENT_TYPE_ENUM.OCCUPATION]: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectEmploymentStatus'),
        },
        [REQUIREMENT_TYPE_ENUM.LOCATION]: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectCity'),
        },
        [REQUIREMENT_TYPE_ENUM.PROFILE_TYPE]: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectType'),
        },
        [REQUIREMENT_TYPE_ENUM.OTHERS]: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterDescriptionRequirement'),
        },
    },
}
